import { useCallback } from "react";
import { FaHamburger } from "react-icons/fa";
import { MdLocalLaundryService } from "react-icons/md";
import {
  CombinedLaundretteDetails,
  useLaundrettesSearch,
} from "../../../data/laundrette.api";
import { SearchSource } from "../MapSearch";

export const useLaundrettesSource = (
  query: string
): SearchSource<CombinedLaundretteDetails> => ({
  title: "Laundrettes",
  source: useLaundrettesSearch(query),
  transformer: useCallback(
    (e) => ({
      icon: MdLocalLaundryService,
      iconColour: "blue.400",
      title: e.overview.laundryroom.site.toLowerCase(),
      subtitle: `${
        e.overview.laundryroom.available_dryers +
        e.overview.laundryroom.available_washers
      } laundry machines available`,
      to: `/laundry/${e.overview.laundryroom.location}`,
    }),
    []
  ),
  priority: 2,
});
